import React from "react";

export default function About() {
  return (
    <div className="pt-20 px-6 max-w-5xl mx-auto text-white">
      <h1 className="text-3xl font-bold mb-6">About CruiseRadar</h1>
      
      <p className="text-white/80 mb-6">
        CruiseRadar is a live, interactive cruise ship map that lets you track ships around the world in real time. Our map shows every vessel’s current position, speed, estimated fuel burn, and fuel costs — both in real time and projected annually. Whether you’re a cruise enthusiast, a maritime professional, or just curious about ships at sea, CruiseRadar gives you a detailed, data-driven look at the world’s largest passenger vessels.
      </p>

      <h2 className="text-2xl font-semibold mb-4 mt-6">
        Live Cruise Ship Tracking
      </h2>
      <p className="text-white/70 mb-4">
        See where cruise ships are sailing at any moment. Our map updates in real time, giving you the most accurate AIS-based positions. You can check the ship’s speed, heading, and location anywhere in the world. Perfect for tracking your upcoming cruise, following your favorite cruise lines, or just exploring the oceans from home.
      </p>

      <h2 className="text-2xl font-semibold mb-4 mt-6">
        Estimated Fuel Burn and Costs
      </h2>
      <p className="text-white/70 mb-4">
        CruiseRadar also estimates fuel consumption and fuel costs for each ship. You can see how much fuel a vessel is burning right now, as well as annualized estimates. This gives insight into operational costs, environmental impact, and energy efficiency of the world’s largest cruise ships.
      </p>

      <h2 className="text-2xl font-semibold mb-4 mt-6">
        Top 10 Fastest Ships
      </h2>
      <p className="text-white/70 mb-4">
        Curious which cruise ships are the fastest? CruiseRadar ranks the top 10 ships by speed using live AIS data. From massive Oasis-class ships to smaller, nimble vessels, you can see which ships are cutting through the waves the fastest — updated continuously.
      </p>

      <h2 className="text-2xl font-semibold mb-4 mt-6">
        Top 10 Ships by Fuel Burn
      </h2>
      <p className="text-white/70 mb-6">
        Want to know which ships consume the most fuel? Our live rankings show the top 10 cruise ships by fuel burn. You can view current consumption as well as annualized estimates. This feature is great for cruise enthusiasts, environmental researchers, or anyone interested in the operational side of cruising.
      </p>

      <h2 className="text-2xl font-semibold mb-4 mt-6">
        Why CruiseRadar Exists
      </h2>
      <p className="text-white/70 mb-6">
        CruiseRadar was built for anyone who loves cruise ships and wants more insight into the world of maritime travel. Whether you’re planning a vacation, studying ship operations, or just fascinated by these floating cities, CruiseRadar provides a clear, interactive, and informative experience. All the data you see comes from AIS (Automatic Identification System) sources and is updated in real time.
      </p>

      <p className="text-white/80">
        Explore our interactive map, check the rankings, or browse our blog for cruise tips, ship reviews, and industry insights. CruiseRadar makes it easy to follow ships at sea and understand how they move, perform, and operate — in one place.
      </p>

      <h2 className="text-2xl font-semibold mb-4 mt-6">
        Vessel Vibes
      </h2>
      <p className="text-white/80 mb-6">
        CruiseRadar was built by <strong>Vessel Vibes</strong>, a cruise media brand big on Instagram, TikTok, and YouTube. With a lifelong passion for ships and years of cruising all over the world, Vessel Vibes created CruiseRadar to share interesting knowledge, ship insights, and real-time tracking for fellow cruise enthusiasts.
      </p>
      <br />
      <br />
    </div>
  );
}
